import { h } from '@stencil/core';
import { NO_LETTERS_AND_LEADING_ZERO_REGEXP, RUNTIME_FIELD_MAX_LENGTH } from '../constants';
import { getMinValue } from '../utils';
export class RuntimeField {
  handleValueChange(value) {
    this.pesRuntimeDidInput.emit(value);
  }
  constructor() {
    this.inputRef = null;
    this.selectValue = '';
    this.getSelectValue = ({ target }) => {
      this.selectValue = target.value;
    };
    this.handleInput = (event) => {
      const target = event.target;
      let { value } = target;
      if (NO_LETTERS_AND_LEADING_ZERO_REGEXP.test(value)) {
        value = this.selectValue + value.replace(NO_LETTERS_AND_LEADING_ZERO_REGEXP, '');
      }
      this.selectValue = '';
      this.setValue(value);
    };
    this.handleChange = (event) => {
      const { value } = event.target;
      this.pesRuntimeDidSubmit.emit(value);
    };
    this.labels = undefined;
    this.isError = false;
    this.defaultValue = '';
    this.hideMinMaxRange = false;
    this.min = undefined;
    this.max = undefined;
    this.value = '';
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentDidLoad() {
    var _a;
    (_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.addEventListener('select', this.getSelectValue);
    this.setValue(this.defaultValue);
  }
  setValue(value) {
    this.inputRef.value = value;
    this.value = value;
  }
  getLoadRangeText() {
    var _a, _b;
    return `${(_a = this.labels) === null || _a === void 0 ? void 0 : _a.minMax} ${getMinValue(this.max, this.min)}-${this.max} ${(_b = this.labels) === null || _b === void 0 ? void 0 : _b.watts}`;
  }
  render() {
    var _a, _b, _c, _d;
    return (h("div", { class: "runtime-field" }, h("pes-runtime-heading-cell", { class: "runtime-field__row", tooltipText: (_a = this.labels) === null || _a === void 0 ? void 0 : _a.enterTotalLoad }, h("div", { class: "runtime-field__label" }, (_b = this.labels) === null || _b === void 0 ? void 0 : _b.runTime), h("input", { class: {
        'runtime-field__input': true,
        'runtime-field__input--error': this.isError,
      }, type: "text", maxLength: RUNTIME_FIELD_MAX_LENGTH, ref: (el) => {
        this.inputRef = el;
      }, onTouchStart: this.getSelectValue, onInput: this.handleInput, onChange: this.handleChange }), ((_c = this.labels) === null || _c === void 0 ? void 0 : _c.watts) && h("span", { class: "runtime-field__measure" }, (_d = this.labels) === null || _d === void 0 ? void 0 : _d.watts)), !this.hideMinMaxRange && (h("div", { class: "runtime-field__row" }, h("div", { class: "runtime-field__load-range" }, h("span", { class: "runtime-field__load-range-text" }, this.getLoadRangeText()))))));
  }
  static get is() { return "pes-runtime-field"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-runtime-field.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-runtime-field.css"]
    };
  }
  static get properties() {
    return {
      "labels": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRuntimeTranslations",
          "resolved": "{ enterTotalLoad: string; enteredLoadLessMinimum: string; hours: string; indicatesCapacity: string; maxCapacityUsed: string; minMax: string; minutes: string; pleaseEnterLoad: string; pleaseEnterLoadMaxCapacity: string; runTime: string; seconds: string; totalLoadExceeds: string; watts: string; }",
          "references": {
            "TRuntimeTranslations": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "runtime translations"
        }
      },
      "isError": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "change border color to red"
        },
        "attribute": "is-error",
        "reflect": false,
        "defaultValue": "false"
      },
      "defaultValue": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "default value to put into input after component is loaded"
        },
        "attribute": "default-value",
        "reflect": false,
        "defaultValue": "''"
      },
      "hideMinMaxRange": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "hide load range info"
        },
        "attribute": "hide-min-max-range",
        "reflect": false,
        "defaultValue": "false"
      },
      "min": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "minimum load range number"
        },
        "attribute": "min",
        "reflect": false
      },
      "max": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "maximum load range number"
        },
        "attribute": "max",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "value": {}
    };
  }
  static get events() {
    return [{
        "method": "pesRuntimeDidSubmit",
        "name": "pesRuntimeDidSubmit",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        }
      }, {
        "method": "pesRuntimeDidInput",
        "name": "pesRuntimeDidInput",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "el"; }
  static get watchers() {
    return [{
        "propName": "value",
        "methodName": "handleValueChange"
      }];
  }
}
